import { render, staticRenderFns } from "./CampaignScreens.vue?vue&type=template&id=164bbc7e&"
import script from "./CampaignScreens.vue?vue&type=script&lang=ts&"
export * from "./CampaignScreens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports